import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import WidgetsIcon from '@mui/icons-material/Widgets';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import GavelIcon from '@mui/icons-material/Gavel';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';

const ServicesSection = styled(Box)(({ theme }) => ({
  padding: '96px 0 90px 0',
  backgroundColor: theme.palette.background.default,
}));

const ServiceCard = styled(Card)(({ theme }) => ({
  height: '100%',
  padding: '32px 22px 32px 22px',
  borderRadius: 18,
  boxShadow: '0 2px 16px rgba(44,76,124,0.07)',
  transition: 'transform 0.28s cubic-bezier(.4,2,.6,1), box-shadow 0.28s cubic-bezier(.4,2,.6,1)',
  cursor: 'pointer',
  background: theme.palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '&:hover': {
    transform: 'translateY(-8px) scale(1.035)',
    boxShadow: '0 8px 32px rgba(201,167,76,0.13)',
    background: '#222',
  },
}));

const IconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(2.5),
  transition: 'transform 0.4s cubic-bezier(.4,2,.6,1)',
  fontSize: 64,
  color: theme.palette.primary.main,
  background: '#181818',
  borderRadius: '50%',
  width: 80,
  height: 80,
  boxShadow: '0 2px 8px rgba(201,167,76,0.10)',
  marginLeft: 'auto',
  marginRight: 'auto',
  '.MuiCard-root:hover &': {
    transform: 'scale(1.18) rotate(-8deg)',
    color: '#c9a74c', // use gold directly
    background: '#222',
  },
}));

const Services = () => {
  const { t } = useTranslation();

  const services = [
    {
      icon: <DirectionsBoatIcon fontSize="inherit" />, // Marine Cargo
      title: 'services.marineCargo.title',
      description: 'services.marineCargo.description',
    },
  ];

  return (
    <ServicesSection id="services">
      <Container>
        <Typography variant="h2" component="h2" align="center" gutterBottom sx={{ fontWeight: 800, mb: 5, color: '#c9a74c', letterSpacing: '-1px' }}>
          {t('services.title')}
        </Typography>
        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <ServiceCard>
                <CardContent>
                  <IconWrapper>{service.icon}</IconWrapper>
                  <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, color: '#fff', fontSize: '1.25rem', mb: 1.5, textAlign: 'center' }}>
                    {t(service.title)}
                  </Typography>
                  <Typography sx={{ color: '#c9a74c', fontWeight: 400, fontSize: '1.08rem', textAlign: 'center', opacity: 1 }}>
                    {t(service.description)}
                  </Typography>
                </CardContent>
              </ServiceCard>
            </Grid>
          ))}
        </Grid>
      </Container>
    </ServicesSection>
  );
};

export default Services; 